import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { checkIsCanvasTest } from 'site-modules/shared/components/canvas/canvas-promo/canvas-promo';

function CanvasLocationSyncUI({ isCanvasIframe, zipCode, iframeRef, setModelValue, isIframeLogic }) {
  useEffect(() => {
    if (isIframeLogic && isCanvasIframe) {
      window?.parent?.postMessage({ zipCode }, '*');
    }
  }, [zipCode, isCanvasIframe, isIframeLogic]);

  useEffect(() => {
    if (isIframeLogic) {
      return noop;
    }

    function onMessage(event) {
      if (event.source === iframeRef?.current?.contentWindow && event?.data?.zipCode) {
        setModelValue('location', VisitorModel, { zipCode: event.data.zipCode });
      }
    }

    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIframeLogic]);

  return null;
}

CanvasLocationSyncUI.propTypes = {
  setModelValue: PropTypes.func.isRequired,
  iframeRef: PropTypes.shape({ current: PropTypes.shape() }),
  zipCode: PropTypes.string,
  isCanvasIframe: PropTypes.bool,
  isIframeLogic: PropTypes.bool,
};

CanvasLocationSyncUI.defaultProps = {
  iframeRef: null,
  zipCode: null,
  isCanvasIframe: false,
  isIframeLogic: false,
};

const mapStateToProps = state => ({
  isCanvasIframe: checkIsCanvasTest(state, { isIframe: true }),
});

export const CanvasLocationSync = connect(mapStateToProps)(
  connectToModel(CanvasLocationSyncUI, {
    zipCode: bindToPath('location.zipCode', VisitorModel),
  })
);
